module.exports = __webpack_public_path__ + "images/line_lp/main-content-heading-left_a30fa67bf75216c6607c29ce1debde3d.png";